import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { Location, LocationDTO } from '../../../../core/models/location.interface';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from '../../../../core/services/loading/loading';
import { LocationService } from '../../../../core/services/location/location-service';
import { FormUtils } from '../../../../shared/utils';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-location-form',
  imports: [
    MatFormField,
    ReactiveFormsModule,
    MatLabel,
    MatInput,
    MatError,
    MatIcon,
    MatIconModule,
    FormsModule,
  ],
  templateUrl: './location-form.html',
  styleUrl: './location-form.scss',
})
export class LocationForm {
  location: string | null = null;
  errorMsg: string[] | null = null;
  locationSelected: Location | null = null;
  private formBuilder = inject(FormBuilder);

  constructor(
    private dialogRef: MatDialogRef<LocationForm>,
    private toastr: ToastrService,
    private serviceLocation: LocationService,
    private loadingService: LoadingService,
  ) {}

  ngOnInit(): void {
    this.serviceLocation.asyncErrorValidation$.subscribe((error) => {
      if (error) {
        this.errorMsg = FormUtils.parseErrorMsgs(error);
      }
    });

    this.serviceLocation.selectedlocation$.subscribe((location) => {
      if (location) {
        this.location = String(location.id);
        this.locationSelected = location;
        this.locationForm.patchValue({
          ...location,
        });
      }
    });
  }

  locationForm = this.formBuilder.group({
    countryCode: ['', [Validators.required, Validators.maxLength(10)]],
    country: ['', [Validators.required, Validators.maxLength(50)]],
    departmentCode: ['', [Validators.required, Validators.maxLength(10)]],
    department: ['', [Validators.required, Validators.maxLength(50)]],
    cityCode: ['', [Validators.required, Validators.maxLength(10)]],
    city: ['', [Validators.required, Validators.maxLength(100)]],
  });

  closeDialog() {
    this.dialogRef.close();
  }

  saveLocation() {
    const payload = this.locationForm.value as LocationDTO;
    if (this.locationForm.status === 'VALID' && !this.location) {
      this.loadingService.show(true);
      this.serviceLocation.createLocation(payload).subscribe({
        next: (location) => {
          this.loadingService.show(false);
          const msg = `La ubicación ${location.city} fue CREADA correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    } else if (this.locationForm.status === 'VALID' && this.location) {
      this.loadingService.show(true);
      const id = Number(this.location);
      this.serviceLocation.UpdateLocation(id, { ...payload, id: id }).subscribe({
        next: (location) => {
          this.loadingService.show(false);
          const msg = `La ubicación ${location.city} fue EDITADA correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    }
  }
}
